export default __webpack_public_path__ + "static/media/result.045306b3.svg";